import { STATIC_FIELDS } from './common';

import { hasProperty } from '../../../util/jquery';

const Ratings = {
    FVUncertainty: {
        '1': 'Low',
        '2': 'Medium',
        '3': 'High',
        '4': 'Very High',
        '5': 'Extreme'
    }
};

export const marketStaticTransforms = data => {
    const statics = [];
    if (!data.data) {
        return statics;
    }
    data.data.forEach(items => {
        let [field, inputKey] = [[], ''];
        for (const item in items) {
            if (item === 'InputKey') {
                inputKey = items[item];
            } else if (hasProperty(STATIC_FIELDS, item.toUpperCase())) {
                let name = STATIC_FIELDS[item.toUpperCase()];
                let value = items[item];
                if (item === 'st160') {
                    value = items[item] || items['S1314'] / 1000000;
                } else if (item === 'st201') {
                    value = Ratings[name][value];
                } else if (/.*Date/i.test(name)) {
                    value = value.replace(
                        /(\d+)(-|\.)(\d+)(-|\.)(\d+)/,
                        '$5$1$3'
                    );
                } else if (item === 'st299') {
                    // dividendYieldCurrent dataPoint stock use st299, none-stock use pm032
                    value =
                        items['secType'] === 'ST'
                            ? items[item]
                            : items['pm032'];
                }
                field.push({
                    name,
                    value
                });
            }
        }
        statics.push({
            statics: field,
            inputKey: inputKey
        });
    });
    return statics;
};
